export function is_full_url(url) {
  return `${url}`.startsWith('https://') || `${url}`.startsWith('http://');
}

/**
 * @param {string } url
 * @return string
 */
export function base(url) {
    if (is_full_url(url)) {
        return url;
    }

    const { hostname } = new URL(get('/'));

    return 'https://' + hostname + "/" + url?.ltrim("/");
}

/**
 * @param {string } url
 * @return string
 */
export function get(url) {
  if (is_full_url(url)) {
    return url;
  }

  let storeUrl = Salla.config.get("store.url");

  if(!storeUrl){
      storeUrl = window.location.href.split("/").slice(0, -1).join("/");
      Salla.config.set('store.url', storeUrl)
  }

  return storeUrl.rtrim("/") + "/" + url?.ltrim("/");
}

export function domain(url) {
  if (is_full_url(url)) {
    return url;
  }

  return `${Salla.config.get("store.url", window.location.href.split("/").slice(0, -1).join("/")).rtrim("/")}/${url?.ltrim("/")}`
}

export function addParamToUrl(key, value, url) {
  url = url || window.location.href;
  if (!value || !key) {
    return url;
  }
  let regex = new RegExp("([?&])" + key + "=[^&]+[&]?", "g");
  url = url
    .replace(regex, "$1") //remove old one
    .split('#')[0]//remove any hash values ex 'https://my_site.test/brands#brand-section-1'
    .replace(/&$|\?$/, "");// remove the `?` or `&` if it's the last char
  if (url.includes("?")) {
    url += "&";
  } else {
    //avoid cases like this: 'https://my_store.test/ar?test=hi'
    url += (url.endsWith('/') ? "" : "/") + "?";
  }

  return (url + key + "=" + encodeURIComponent(value)).replace(/&$|\?$/, "");
}

//this will get it without username if it's salla domain ex: Salla.sa/test will ignore test
export function baseUrl(path) {
  return window.location.origin + "/" + path?.ltrim("/");
}

export function asset(path) {
  if (is_full_url(path)) {
    return path;
  }
  if (Salla.config.get('theme.assets')) {
    return Salla.config.get('theme.assets').replace(':path',path?.ltrim("/"));
  }

  return baseUrl("themes/" + Salla.config.get("theme.name") + "/" + path?.ltrim("/"));
}

export function cdn(path, width, height) {
  let cdnUrl = "https://cdn.salla.network/";
  if (width || height) {
    width = width ? `,width=${width}` : '';
    height = height ? `,height=${height}` : '';
    cdnUrl += `cdn-cgi/image/fit=scale-down${width}${height},onerror=redirect,format=auto/`;
  }

  return cdnUrl + path?.ltrim("/");
}


/**
 * Constructs a URL based on the provided type and value.
 * 
 * @param type - The type of URL to create.
 * @param value - The value to be used in the URL. This is directly returned if type is 'custom'.
 * @returns {string}
 */

export function create(type, value) {
  if (type === 'custom') {
    return value;
  }
  if (type === 'offers') {
    return get(type);
  }
  return get(`redirect/${type}/${value}`);
}

/**
 * Return url for api
 * @example Salla.url.api('test') => https://my_store.test/api/v1/test
 * @param path
 * @return {string}
 */
export function api(path) {
  return Salla.config.get("store.api", get(""))?.rtrim("/") + "/" + path?.ltrim("/");
}

export function is_page(pageName) {
  return pageName && Salla.config.get("page.slug") === pageName;
}

export function is_placeholder(url) {
  return asset(salla.config.get('theme.settings.placeholder')) === asset(url);
}